import ExcelJS from "exceljs";
import { saveAs } from "file-saver";
import { keyAverage, keyHeader, keyTotal } from "../components/Dashboard/DashboardTable/headers";

export async function downloadExcelWithChartAndData({
  canvasId,
  demandData,
  dataToShow,
  headers,
  isMicrogridSelected,
  isYakubaSelected,
  filename = "combined_data_chart.xlsx",
}) {
  const canvas = document.getElementById(canvasId);
  if (!canvas) {
    console.error(`Canvas with id ${canvasId} not found`);
    return;
  }

  // Prepare image from canvas with black/dark bg
  const offCanvas = document.createElement("canvas");
  offCanvas.width = canvas.width;
  offCanvas.height = canvas.height;
  const ctx = offCanvas.getContext("2d");
  ctx.fillStyle = "#3B3B3B";
  ctx.fillRect(0, 0, offCanvas.width, offCanvas.height);
  ctx.drawImage(canvas, 0, 0);
  const imageBase64 = offCanvas.toDataURL("image/png").replace(/^data:image\/png;base64,/, "");


  const workbook = new ExcelJS.Workbook();


  if (isMicrogridSelected && isYakubaSelected && demandData) {
    const yakuba = demandData.kushiro_yakuba || {};
    const microgrid = demandData.kushiro_microgrid || {};

  const sumArrays = (arr1, arr2) =>
    arr1.map((val, idx) => {
      const sum = val + (arr2[idx] || 0);
      return Math.round(sum * 10) / 10;
    });

     const mixHeaders = {
    項目: yakuba?.id,
    時間: yakuba?.time,
    "気温(℃)": yakuba?.temperature,
    "日射量(kWh/m²)": yakuba?.radiation,
     "発電予測量(kWh)役場":sumArrays(yakuba?.rooftop_gen, yakuba?.carpot_gen),
    "発電予測量(kWh)MG" : microgrid?.generation,
    "発電予測量(kWh)役場+MG":sumArrays(sumArrays(yakuba?.rooftop_gen, yakuba?.carpot_gen),microgrid?.generation),
    "需要予測量(kWh)役場": yakuba?.demand,
    "需要予測量(kWh)MG": microgrid?.total_demand,
    "需要予測量(kWh)役場+MG": sumArrays(yakuba?.demand, microgrid?.total_demand),
    "購入予測量(kWh)役場": yakuba?.purchase,
    "購入予測量(kWh)MG": microgrid?.purchase,
    "購入予測量(kWh)役場+MG": sumArrays(
      yakuba?.purchase,
      microgrid?.purchase
    ),
  };
const keyMixHeader = ["項目"];
   const keyMixAverage = ["気温(℃)"];
     const keyMixTotal = [
    "発電予測量(kWh)役場",
    "発電予測量(kWh)MG",
    "発電予測量(kWh)役場+MG",
    "発電予測量(kWh)",
    "需要予測量(kWh)役場",
    "需要予測量(kWh)MG",
    "需要予測量(kWh)役場+MG",
    "購入予測量(kWh)役場",
    "購入予測量(kWh)MG",
    "購入予測量(kWh)役場+MG",
  ];

  const keys = Object.entries(mixHeaders);

    const rowCount = (yakuba.id?.length || 0);
    const mixSheet = workbook.addWorksheet(" 釧路町役場 + マイクログリッド データ");


    mixSheet.addRow(Object.keys(mixHeaders));

 

    for (let i = 0; i < rowCount; i++) {
      mixSheet.addRow([
        yakuba.id?.[i] ?? "",
        yakuba.time?.[i] ?? "",
        yakuba.temperature?.[i] ?? "",
        yakuba.radiation?.[i] ?? "",
        yakuba.rooftop_gen?.[i] ?? "",
        yakuba.carpot_gen?.[i] ?? "",
        microgrid.generation?.[i] ?? "",
        yakuba.demand?.[i] ?? "",
        microgrid.total_demand?.[i] ?? "",
        Math.round(((yakuba.demand?.[i] ?? 0) + (microgrid.total_demand?.[i] ?? 0)) * 10) / 10,
        yakuba.purchase?.[i] ?? "",
        microgrid.purchase?.[i] ?? "",
        Math.round(((yakuba.purchase?.[i] ?? 0) + (microgrid.purchase?.[i] ?? 0)) * 10) / 10,
      ]);
    }



      const summaryRow = keys.map(([key, value]) => {
        if (keyMixHeader.includes(key)) {
          return "合計 / 平均";
        } else if (keyMixAverage.includes(key)) {
        const values = Array.isArray(value) ? value : [value];
          const numericValues = values.filter((v) => !isNaN(parseFloat(v)));
          return numericValues.length
            ? (
              numericValues.reduce((sum, val) => sum + parseFloat(val), 0) /
              numericValues.length
            ).toFixed(1)
            : "-";
        } else if (keyMixTotal.includes(key)) {
         const values = Array.isArray(value) ? value : [value];
          const numericValues = values.filter((v) => !isNaN(parseFloat(v)));
          return numericValues.length
            ? numericValues
              .reduce((sum, val) => sum + parseFloat(val), 0)
              .toFixed(1)
            : "-";
        } else {
          return "-";
        }
      });

      mixSheet.addRow(summaryRow);


      const lastRow = mixSheet.lastRow;
      lastRow.font = { bold: true };
      lastRow.eachCell((cell) => {
        if (cell.value === "-") {
          cell.alignment = { horizontal: "center" }
        } else {
          cell.alignment = { horizontal: "right" }
        }
      });

  } else {
    if (dataToShow && headers) {
      const keys = Object.keys(headers);
      const rowCount = dataToShow[keys[0]]?.length || 0;
      const dataSheetName = isYakubaSelected ? "釧路町役場 データ" : "マイクログリッド データ";
      const dataSheet = workbook.addWorksheet(dataSheetName);


      dataSheet.addRow(keys.map((key) => headers[key]));


      for (let i = 0; i < rowCount; i++) {
        const row = keys.map((key) => dataToShow[key]?.[i] ?? "");
        dataSheet.addRow(row);
      }


      const summaryRow = keys.map((key) => {
        if (keyHeader.includes(key)) {
          return "合計 / 平均";
        } else if (keyAverage.includes(key)) {
          const values = dataToShow[key] || [];
          const numericValues = values.filter((v) => !isNaN(parseFloat(v)));
          return numericValues.length
            ? (
              numericValues.reduce((sum, val) => sum + parseFloat(val), 0) /
              numericValues.length
            ).toFixed(1)
            : "-";
        } else if (keyTotal.includes(key)) {
          const values = dataToShow[key] || [];
          const numericValues = values.filter((v) => !isNaN(parseFloat(v)));
          return numericValues.length
            ? numericValues
              .reduce((sum, val) => sum + parseFloat(val), 0)
              .toFixed(1)
            : "-";
        } else {
          return "-";
        }
      });

      dataSheet.addRow(summaryRow);


      const lastRow = dataSheet.lastRow;
      lastRow.font = { bold: true };
      lastRow.eachCell((cell) => {
        if (cell.value === "-") {
          cell.alignment = { horizontal: "center" }
        } else {
          cell.alignment = { horizontal: "right" }
        }
      });

    }

  }






  const chartSheet = workbook.addWorksheet("チャート");
  const imageId = workbook.addImage({
    base64: imageBase64,
    extension: "png",
  });
  chartSheet.addImage(imageId, {
    tl: { col: 0, row: 0 },
    ext: { width: 1500, height: 400 },
  });


  const buffer = await workbook.xlsx.writeBuffer();
  saveAs(new Blob([buffer]), filename);
}
